/**
 * Validation Schemas Index
 *
 * Central export point for all validation schemas and utilities
 */

// Common utilities and types
export * from "./common";

// Resource-specific schemas - explicit exports to avoid conflicts
export {
  forgotPasswordSchema,
  invitationDataSchema,
  passwordChangeSchema,
  permissionLevelSchema,
  profileUpdateSchema,
  resetPasswordSchema,
  signinSchema,
  signupSchema,
  userManageSchema,
  userUpdateSchema,
  // Individual field validators removed - unused (forms use Zod schemas directly)
  type ForgotPasswordForm,
  type InvitationData,
  type PasswordChangeForm,
  type ProfileUpdateForm,
  type ResetPasswordForm,
  type SigninForm,
  type SignupForm,
  type UserManageForm,
  type UserUpdateForm,
} from "./users";

export {
  invitationCreateSchema,
  invitationUpdateSchema,
  // Individual field validators removed - unused (forms use Zod schemas directly)
  type InvitationCreateForm,
  type InvitationUpdateForm,
} from "./invitations";

export * from "./aggregates";
export * from "./billing";
export * from "./admin-billing";
export * from "./clients";
export * from "./external-systems";
export * from "./labs";
export * from "./locations";

export {
  sampleBulkDetailsUpdateSchema,
  sampleBulkEditFormSchema,
  sampleCreationSchema,
  SAMPLING_METHOD_VALUES,
  samplingMethodSchema,
  type SampleBulkDetailsUpdateInput,
  type SampleBulkEditForm,
  type SampleCreationForm,
} from "./samples";

export {
  analysisArchiveSchema,
  analysisBulkCancelSignOffSchema,
  analysisBulkEditFormSchema,
  analysisBulkRequestSignOffSchema,
  analysisBulkSignOffSchema,
  analysisBulkUnlockSchema,
  analysisBulkUpdateSchema,
  analysisBulkWorkflowSchema,
  analysisSignOffSchema,
  analysisUnlockSchema,
  gradationFormSchema,
  gradationPayloadSchema,
  inputFormatSchema,
  massUnitSchema,
  newAnalysisFormSchema,
  sieveRowSchema,
  staticImagingImagesPatchSchema,
  washLossFormSchema,
  type AnalysisArchiveForm,
  type AnalysisBulkEditForm,
  type AnalysisBulkUpdateInput,
  type AnalysisBulkWorkflowInput,
  type AnalysisSignOffForm,
  type AnalysisUnlockForm,
  type GradationForm,
  type GradationPayload,
  type InputFormat,
  type MassUnit,
  type NewAnalysisForm,
  type SieveRowForm,
  type StaticImagingImagesPatchForm,
  type WashLossForm,
} from "./analyses";

// Re-export commonly used Zod utilities
export { z } from "zod";
